<div class="data-information">
  
    <ng-icon size="2em" [name]="icon"></ng-icon>
    <div class="middle">
      <div class="title">
        {{ titleText }}
      </div>
      <div class="total">
        {{
          data! | formatDataValue
        }}
      </div>
    </div>
  </div>
